<script>
import formatCurrency from "@utils/format-currency";
import { categoryFilter, storeFilter } from "@utils/ipetbooking-filter";
import { authComputed, merchantComputed } from '@store/helpers'
import { prepaidFormatUsedTimes, prepaidHasInventory } from "@utils/ipetbooking-prepaid";
import setWindowHistory from "@utils/window-history";
import formatPrice from "@utils/format-price";
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

const DEFAULT_FILTER = {
  storesAlias: [],
  petCategoriesAlias: []
};

export default {
  name:'SectionList2',
  components: {
    PrepaidItem: () => import("./PrepaidItem"),
  },
  props: {
    prepaidList: {
      type: Array,
      default: () => {
        return [
          {
            alias: "mini-dog-a",
            basePrice: 700,
            infinity: 1,
            introimage: null,
            introtext: null,
            inventory: 0,
            name: "小捲尾招牌沐浴SPA(迷你犬)超值特惠組（單一）",
            price: 700,
            qty: 1,
            slogan: null,
          },
        ]
      }
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          current_page: 1,
          first_page_url: "http://admin.ds.test/api/merchant/prepaids?page=1",
          from: 1,
          last_page: 1,
          last_page_url: "http://admin.ds.test/api/merchant/prepaids?page=1",
          next_page_url: null,
          path: "http://admin.ds.test/api/merchant/prepaids",
          per_page: 6,
          prev_page_url: null,
          to: 3,
        }
      }
    },
    errorText: {
      type: String,
      default: '',
    },
    filter: {
      type: Object,
      default: () => {
        return {
          storesAlias: [],
          petCategoriesAlias: []
        }
      },
    }
  },
  data() {
    return {
      filterList: {
        store: Object.freeze(storeFilter()),
        category: Object.freeze(categoryFilter())
      },
      tempPrepaidAlias: '',
      isShowFilter: false,
      filterType: 'click'
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    filterData: {
      get() {
        return this.filter
      },
      set(value) {
        this.$emit('update:filter', value)
      },
    },
    buttonBarList() {
      return [
        {
          text: '清除重填',
          class: 'flex-grow-1',
          buttonClass: this.$globalIsDingBeauty ?  'isStyleSecondary isOutline3 isSmall isFull' :  'isStylePrimary isOutline3 isRadius isSmall isFull',
          onClick: () => {
            this.clearFilter()
          },
        },
        {
          text: '套用篩選',
          class: 'flex-grow-1',
          buttonClass: this.$globalIsDingBeauty ? 'isStylePrimary isSmall isFull' : "isStylePrimary isRadius isSmall isFull",
          onClick: () => {
            this.onSearch()
          },
        },
      ]
    },
    isHasHeader() {
      return !this.$globalIsLiffClient || this.$route.meta.liffShowMenu
    },
  },
  mounted() {
    const initResizeListener = () => {
      window.addEventListener('resize', this.setFilterType)
    };

    this.setFilterType();
    initResizeListener();
  },
  destroyed() {
    const removeResizeListener = () => {
      window.removeEventListener('resize', this.setFilterType)
    };

    removeResizeListener();
  },
  methods: {
    prepaidHasInventory,
    prepaidFormatUsedTimes,
    formatPrice,
    formatTextUpperCasefirst,
    formatCurrency,
    goToPrepaidItem({ prepaidAlias }) {
      this.$router.push({
        name: 'prepaid-item',
        params: {
          prepaidAlias
        },
      })
    },
    async tryToStoreCart({ prepaidAlias }) {
      if(this.$isLoading('storeCart')) {
        return false;
      }

      this.tempPrepaidAlias = prepaidAlias;

      await this.$store.dispatch('cart/storeCart', {
        prepaidAlias,
      })
        .then(() => {
          return true
        })
    },
    onClickItem({ prepaidAlias }) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          if(this.isBlock) {
            this.$globalDialog('DialogBlock', {})
            return
          }
          this.tryToStoreCart({ prepaidAlias })
            .then(() => {
              const goToPrepaidCheckout = () => {
                this.$router.push({
                  name: 'prepaid-checkout',
                  params: {
                    prepaidAlias
                  }
                });
              };

              goToPrepaidCheckout()
            })
            .catch((e) => {
              if(e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })
        });
      };

      if(this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    onChangeFilter() {
      this.$emit('changeFilter', this.filterData)
    },
    onChangePagination(value) {
      this.$emit('changePagination', value)
    },
    clearFilterAndSearch() {
      this.clearFilter();
      this.onSearch();
    },
    clearFilter() {
      Object.keys(this.filterData)
        .forEach(key => {
          this.filterData[key] = DEFAULT_FILTER[key];

          setWindowHistory({
            query: {
              ...this.$route.query,
              [`filter${this.formatTextUpperCasefirst(key)}`]: DEFAULT_FILTER[key] || undefined
            }
          });
        });
    },
    onSearch() {
      this.isShowFilter = false;
      this.$emit('changeFilter', this.filterData)
    },
    setFilterType() {
      this.filterType = document.body.clientWidth > 767
        ? 'prompt'
        : 'click';
    }
  }
}
</script>
<!-- section template -->
<template>
  <section :class="$style.sectionList" class="section">
    <div
      :class="[$style.filterBtn, { [$style.isShowFilter]: isShowFilter, isHasHeader: isHasHeader }]"
      @click="isShowFilter = true"
    >
      <i class="far fa-sliders-h"></i> 篩選
    </div>
    <div class="container">
      <template v-if="!!errorText">
        <BaseError
          :title="errorText"
        />
      </template>
      <div v-else class="row">
        <div class="col-md-3 sectionList__leftBox order-1" :class="{ isShow: isShowFilter }">
          <div class="sectionList__leftBoxInner">
            <div :class="$style.filterHead" class="d-flex d-md-none">
              <h5>篩選方案</h5>
              <BaseButton
                class="isText "
                @click="isShowFilter = false"
              >
                <i style="font-size: 18px;" class="fontello fontello-cross"></i>
              </BaseButton>
            </div>
            <BaseFilter
              v-if="!!filterList.store[0]"
              v-model="filterData.storesAlias"
              name="filterStoresAlias"
              :type="filterType"
              title="分店"
              :filter-list="filterList.store"
              @change="onChangeFilter"
            />
            <hr>
            <BaseFilter
              v-if="!!filterList.category[0] && filterList.category.length > 1"
              v-model="filterData.petCategoriesAlias"
              name="filterCategoriesAlias"
              :type="filterType"
              title="類型"
              :filter-list="filterList.category"
              can-collapse
              @change="onChangeFilter"
            />
            <BaseButtonBar
              :button-list="buttonBarList"
              is-show
              class="d-md-none"
            />
            <BasePre>filterData:{{ filterData }}</BasePre>
          </div>
        </div>
        <div class="col-md-9 sectionList__rightBox">
          <template v-if="$isLoading('fetchPrepaidList') || prepaidList[0]">
            <div class="sectionList__rightBoxInner">
              <el-skeleton
                :loading="$isLoading('fetchPrepaidList')"
                animated
                :throttle="600"
              >
                <template slot="template">
                  <div
                    class="row"
                    :class="$style.skeletonList"
                  >
                    <div
                      v-for="n in prepaidList.length || 2"
                      :key="n"
                      class="col-lg-6 skeletonList__item"
                    >
                      <el-skeleton-item
                        class="skeletonList__image"
                        variant="image"
                      />
                      <el-skeleton-item
                        class="skeletonList__tag"
                        variant="rect"
                      />
                      <el-skeleton-item
                        class="skeletonList__title"
                        variant="rect"
                      />
                      <el-skeleton-item
                        class="skeletonList__title2"
                        variant="rect"
                      />
                      <el-skeleton-item
                        class="skeletonList__description"
                        variant="rect"
                      />
                      <el-skeleton-item
                        class="skeletonList__description2"
                        variant="rect"
                      />
                      <!--<el-skeleton-item
                        class="skeletonList__price"
                        variant="rect"
                      />-->
                      <el-skeleton-item
                        class="skeletonList__button"
                        variant="rect"
                      />
                    </div>
                  </div>
                </template>
                <!-- section template -->
                <template>
                  <div
                    class="row"
                    :class="$style.prepaidList"
                  >
                    <div
                      v-for="(prepaidItem, index) in prepaidList"
                      :key="`prepaidItem-${index}`"
                      class="col-lg-6 prepaidList__item"
                    >
                      <PrepaidItem
                        :prepaid-item="prepaidItem"
                      />
                    </div>
                  </div>
                </template>
              </el-skeleton>
              <BasePagination
                v-if="!!prepaidList[0] && pagination.last_page > 1"
                class="sectionList__pagination"
                :pagination="pagination"
                @change="onChangePagination"
              />
            </div>
          </template>
          <template v-else-if="filter.storesAlias.length === 0 && filter.petCategoriesAlias.length === 0">
            <BaseNull
              :image="`${ require('@assets/images/reservation/no-record.svg') }`"
              :title="`尚無任何${currentMerchant.prepaidSetting.title || '包套方案'}`"
            />
          </template>
          <template v-else>
            <BaseNull
              :image="`${ require('@assets/images/reservation/no-record.svg') }`"
              :title="`沒有符合搜尋條件的${currentMerchant.prepaidSetting.title || '包套方案'}`"
            >
              <BaseButton
                class="isStylePrimary isOutline3 isRadius mt-5 isCol4"
                @click="clearFilterAndSearch"
              >
                <span>清除條件</span>
              </BaseButton>
            </BaseNull>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.sectionList {
  // min-height: 900px;

  @include max-md {
    position: relative;
    padding-top: 0;
  }

  :global {
    .sectionList {
      &__leftBox {
        position: sticky;
        top: 160px;
        padding-right: 87px;

        @include max-xl {
          padding-right: 30px;
        }

        @include max-md {
          @include var-height(100);

          position: fixed;
          top: 76px;
          left: 0;
          z-index: 2000;
          display: none;
          padding-top: 1rem;
          padding-right: 15px;
          padding-bottom: 8rem;
          overflow-y: auto;
          background-color: #FFF;

          &.isShow {
            display: block;
          }
        }

        @include max-md {
          top: 60px;
        }
      }

      &__leftBoxInner {
        position: sticky;
        top: 160px;

        @include max-lg {
          top: 120px;
        }

        @include max-md {
          position: static;
          top: 0;
          padding-left: 1rem;
        }
      }

      &__rightBox {
        @include unstyled;
      }

      &__rightBoxInner {
        position: sticky;
        top: 160px;
      }

      &__pagination {
        position: sticky;
        bottom: 0;
        padding-top: 1rem;
        padding-bottom: 2rem;
        margin-top: -1rem;
        margin-bottom: -2rem;
        background: #FFF;
      }
    }
  }
}

.prepaidList {
  :global {
    .prepaidList {
      margin-bottom: -3rem;

      &__item {
        margin-bottom: 3rem;
      }
    }
  }
}

.skeletonList {
  opacity: 0.8;

  :global {
    .skeletonList {
      &__item {
        margin-bottom: 3.75rem;
      }

      &__image {
        padding-top: 75.5%;
        margin-bottom: 1.25rem;
      }

      &__tag {
        width: 65px;
        height: 21px;
        margin-bottom: 0.25rem;
      }

      &__title {
        width: 100%;
        height: 16px;
        margin-bottom: 0.25rem;
      }

      &__title2 {
        width: 75%;
        height: 16px;
        margin-bottom: 0.5rem;
      }

      &__description {
        width: 100%;
        height: 14px;
        margin-bottom: 0.15rem;
      }

      &__description2 {
        width: 75%;
        height: 14px;
        margin-bottom: 1rem;
      }

      /* &__price {
        width: 90px;
        height: 24px;
        margin-bottom: 1rem;
      } */

      &__button {
        width: 100%;
        height: 61px;
        margin-bottom: -0.5rem;
        border-radius: 10px;
      }
    }
  }
}

.filterBtn {
  position: sticky;
  top: 0;
  z-index: 2;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 3rem;
  text-align: center;
  cursor: pointer;
  background-color: #FFF;
  border-bottom: $color-gray-4 1px solid;


  &.isShowFilter {
    z-index: 1;
  }

  &.isHasHeader {
    top: 59px;
  }

  @include min-md {
    display: none;
  }

  :global {
    .filterBtn {
      @include unstyled;
    }
  }
}

.filterHead {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.4rem;
}
</style>
